import type { ContractShapeOf, RequestHandlers } from 'shared/channels';
import type { checklistAnswerContract } from 'shared/domain/checklistAnswer/checklistAnswerContract';
import { checklistAnswerSaver } from './addChecklistAnswer';
import { checklistAnswerDeleter } from './deleteChecklistAnswer';
import { checklistAnswerEditor } from './editChecklistAnswer';

/** Checklist answer changes put on the HTTP queue, as the channel server runs them. */
export const queueChecklistAnswerChanges = {
  create: ({ answer, uniqueId }) => checklistAnswerSaver.execute(answer, uniqueId),
  edit: ({ answer, uniqueId }) => checklistAnswerEditor.execute(answer, uniqueId),
  remove: ({ answer, uniqueId }) => checklistAnswerDeleter.execute(answer, uniqueId),
} satisfies RequestHandlers<ContractShapeOf<typeof checklistAnswerContract>>;
